import { GROUP_ORDER, type Concept, type ConceptGroup } from './types.js';

export interface GroupedConcepts {
  group: ConceptGroup;
  concepts: Concept[];
}

export function groupConcepts(concepts: Concept[]): GroupedConcepts[] {
  return GROUP_ORDER.map((group) => ({
    group,
    concepts: concepts.filter((c) => c.group === group),
  }));
}
